import { ModelBase } from './model';

class LessonSchedule extends ModelBase {
  static namespace = 'lesson_schedules';
}
export default LessonSchedule.register();
